import { render } from "./memberGrade-edit.vue?vue&type=template&id=efc87556&scoped=true"
import script from "./memberGrade-edit.vue?vue&type=script&lang=js"
export * from "./memberGrade-edit.vue?vue&type=script&lang=js"

import "./memberGrade-edit.vue?vue&type=style&index=0&id=efc87556&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efc87556"]])

export default __exports__